import { render, staticRenderFns } from "./dataDashBoard2.vue?vue&type=template&id=0f6f75ce"
import script from "./dataDashBoard2.vue?vue&type=script&lang=js"
export * from "./dataDashBoard2.vue?vue&type=script&lang=js"
import style0 from "./dataDashBoard2.vue?vue&type=style&index=0&id=0f6f75ce&prod&lang=scss&rel=stylesheet%2Fscss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports